export const checkHoneypot = (): boolean => {
  const honeypotField = document.querySelector('input[name="website"]') as HTMLInputElement
  const value = honeypotField?.value || ''
  const isValid = !value || value.trim() === ''

  if (!isValid) {
    console.warn('Bot detected: honeypot field filled', { value })
  }
  return isValid
}
